// ***************************************
// Definition of game token Playback
// ***************************************
import { tbAnimator } from "../engine/tbAnimator";
import { tbGame } from "../engine/tbGame";
import { SoundManager } from "../settings/SoundManager";
import { ReplayLogger } from "./ReplayLogger";
import { SceneControllerState } from "./SceneController";
import { playController } from "./gameController";
// The constructor for the Playback game token. 
export var Playback = function (data, cameraData, endCallback) {
    "use strict";
    // Properties used by the engine
    this.visible = true;
    this.active = true;
    // Your own properties
    this.endCallback = endCallback;
    this.replayData = data;
    this.replayCameraData = cameraData;
    this.animator = new tbAnimator(this);
    this.currentStep = -45;
    this.nextEvent = 0;
    this.nextCameraEvent = 0;
    // Add it to the game engine
    tbGame.addToken(this);
};
// handleAdd is called when the token is (re-) added to the game. 
Playback.prototype.handleAdd = function () {
    "use strict";
    playController.sceneController.changeState(SceneControllerState.REPLAYING);
    ReplayLogger.startRecording();
    for (var i = 0; i < this.replayData.length; i++) {
        if (this.replayData[i]["blocks"]) {
            this.trigger(i);
            break;
        }
    }
};
// handleRemove is called when the token is removed from the game.
Playback.prototype.handleRemove = function () {
    "use strict";
    this.animator.removeEvents();
};
Playback.prototype.trigger = function (id) {
    "use strict";
    console.log("Replay triggered of id: " + id + "Time data: " + this.replayData[id]["time"]);
    if (this.replayData[id]["shot"]) {
        ReplayLogger.log("Played shot");
        console.log("shoot bird");
        playController.sceneController.slingshotReplayShot(this.replayData[id]["shot"]);
    }
    else if (this.replayData[id]["blocks"]) {
        ReplayLogger.log("Played loadblocks");
        playController.sceneController.replayStateToLoad = this.replayData[id]["blocks"];
        console.log("fix blox");
    }
    else if (this.replayData[id]["special"]) {
        ReplayLogger.log("Played special");
        console.log("special");
        playController.sceneController.specialReplayShot();
    }
    else if (this.replayData[id]["power"]) {
        playController.sceneBuilder.panToDefault = false;
        ReplayLogger.log("Played powerup");
        playController.sceneController.managePowerUpReplay(this.replayData[id]["power"], this.replayData[id]["properties"]);
    }
    else if (this.replayData[id]["startIdle"]) {
        ReplayLogger.log("Played findstart");
        this.findNextStartingPoint();
    }
    else {
        ReplayLogger.log("Played end");
        console.log("Replay Ended");
        if (this.endCallback) {
            this.endCallback();
        }
        playController.sceneBuilder.panToDefault = false;
        ReplayLogger.stopRecording();
    }
};
Playback.prototype.findNextBird = function () {
    for (var i = this.nextEvent; i < this.replayData.length; i++) {
        if (this.replayData[i]["shot"]) {
            return this.replayData[i]["shot"];
        }
    }
};
Playback.prototype.triggerCamera = function (id) {
    if (this.replayCameraData[id].panToSlingshot) {
        playController.sceneBuilder.cameraToSlingshot(true);
        var tempbird = this.replayData[this.nextEvent];
        if (tempbird.shot) {
            tempbird = tempbird.shot;
        }
        else {
            tempbird = this.findNextBird();
        }
        if (!tempbird) {
            // BAIL BAIL BAIL
            console.log("Failed to find bird in replay!");
            return;
        }
        var self = this;
        playController.sceneController.getSlingshot(true).setBirdType(tempbird.selectedBirdName);
        playController.sceneController.getSlingshot(true).StartFakingAim({
            x: tempbird.launchDirection.x * (playController.isInitiatingPlayer ? -100 : 100),
            y: tempbird.launchDirection.y * -100 // make it look like they're taking a shot
        }, function () { });
        SoundManager.playEffect(SoundManager.BIRD_STATE.STRETCH, playController.sceneController.sounds);
        SoundManager.playEffect(SoundManager.SLINGSHOT_STATE.STRETCH, SoundManager.MaterialCollection.SLINGSHOT, 0, true);
        this.stopCounting = true;
    }
    else if (this.replayCameraData[id].panToDefault) {
        playController.sceneBuilder.panToDefault = true;
    }
};
Playback.prototype.updateTime = function () {
    //if(!this.stopCounting)
    this.currentStep++;
    //else return;
    //if event happened, trigger now
    while (this.replayData[this.nextEvent] && this.currentStep === this.replayData[this.nextEvent].time) {
        console.log("Triggered next event, at timestep " + this.currentStep + ", should happen at " + this.replayData[this.nextEvent].time);
        if (this.stopCounting) {
            this.stopCounting = false;
            playController.sceneController.getSlingshot(true).finishFakeAiming();
        }
        this.trigger(this.nextEvent);
        this.nextEvent++;
    }
    while (this.replayCameraData[this.nextCameraEvent] && this.currentStep >= this.replayCameraData[this.nextCameraEvent]["time"]) {
        this.triggerCamera(this.nextCameraEvent);
        this.nextCameraEvent++;
    }
};
Playback.prototype.findNextStartingPoint = function () {
    if (this.replayData[this.nextEvent + 1]) {
        this.currentStep = this.replayData[this.nextEvent + 1]["time"] - 1;
    }
};
// handleBeginStep is called each step before processing other events.
Playback.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    this.animator.updateTime(timePassed);
};
// handleEndStep is called each step after processing other events (before draw).
Playback.prototype.handleEndStep = function (timePassed) {
    "use strict";
};
